import { render, staticRenderFns } from "./hireWorkerCost.vue?vue&type=template&id=5c84c5be&scoped=true&"
import script from "./hireWorkerCost.vue?vue&type=script&lang=js&"
export * from "./hireWorkerCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84c5be",
  null
  
)

export default component.exports